<div class="card">
  <div class="card-body">
    <h5>{{ "DANH SÁCH ĐƠN HÀNG" | translate }}</h5>
    <div class="">
      <div class="row d-flex justify-content-between">
        <div class="form-group col-6 col-md-4 col-lg-3">
          <label for="validationCustom01">{{
            "Chọn trạng thái" | translate
          }}</label>
          <ng-select [(ngModel)]="filter.status" [clearable]="true">
            <ng-option value="" hidden>{{
              "Trạng thái giao hàng" | translate
            }}</ng-option>
            <ng-option *ngFor="let item of listStatus" [value]="item.value">{{
              item.label
            }}</ng-option>
          </ng-select>
        </div>
        <div class="form-group col-6 col-md-4 col-lg-3">
          <label for="validationCustom01">{{
            "Số tài khoản" | translate
          }}</label>
          <input
            type="tel"
            class="form-control"
            [(ngModel)]="filter.terminal_bank_acc"
            placeholder="Nhập số tài khoản"
          />
        </div>
                <div class="form-group col-6 col-md-4 col-lg-3">
          <label for="validationCustom01">{{
            "Số điện thoại" | translate
          }}</label>
          <input
            type="tel"
            class="form-control"
            [(ngModel)]="filter.phone"
            placeholder="Nhập số điện thoại"
          />
        </div>
        <div class="form-group col-6 col-md-4 col-lg-3">
          <label for="validationCustom01">{{
            "SĐT người nhận" | translate
          }}</label>
          <input
            type="tel"
            class="form-control"
            [(ngModel)]="filter.recipientPhone"
            placeholder="Nhập SĐT người nhận"
          />
        </div>
        <div class="form-group col-6 col-md-4 col-lg-3">
          <label for="validationCustom01">{{
            "Mã giao dịch" | translate
          }}</label>
          <input
            type="text"
            class="form-control"
            [(ngModel)]="filter.mb_reference_number"
            placeholder="Nhập mã giao dịch"
          />
        </div>
        <div class="form-group col-6 col-md-4 col-lg-3">
          <label for="validationCustom01">{{
            "Mã thiết bị" | translate
          }}</label>
          <input
            type="text"
            class="form-control"
            [(ngModel)]="filter.serial_number"
            placeholder="Nhập mã thiết bị"
          />
        </div>
        <div class="form-group col-6 col-md-4 col-lg-3">
          <label for="validationCustom01">{{
            "Mã giới thiệu" | translate
          }}</label>
          <input
            type="text"
            class="form-control"
            [(ngModel)]="filter.referrer"
            placeholder="Nhập mã giới thiệu"
          />
        </div>
        <div class="form-group col-6 col-md-4 col-lg-3">
          <label for="validationCustom01">{{ "Mã sim" | translate }}</label>
          <input
            type="text"
            class="form-control"
            [(ngModel)]="filter.sim4g_imsi"
            placeholder="Nhập mã sim"
          />
        </div>
        <div class="form-group col-6 col-md-4 col-lg-3">
          <label for="terminalID">{{ "Terminal ID" | translate }}</label>
          <input
            id="terminalID"
            type="text"
            class="form-control"
            [(ngModel)]="filter.terminalID"
            placeholder="Nhập Terminal ID"
          />
        </div>
        <div class="form-group col-6 col-md-4 col-lg-3">
          <label for="validationCustom01">{{
            "Phương thức giao" | translate
          }}</label>
          <ng-select [(ngModel)]="filter.deliveryMethod" [clearable]="true">
            <ng-option value="" hidden>{{
              "Phương thức giao" | translate
            }}</ng-option>
            <ng-option value="direct">Trực tiếp</ng-option>
            <ng-option value="shipper">Online</ng-option>
          </ng-select>
        </div>
        <div class="form-group col-6 col-md-4 col-lg-3">
          <label for="validationCustom01">{{
            "Loại đơn hàng" | translate
          }}</label>
          <ng-select
            [(ngModel)]="filter.service_package_type"
            [clearable]="false"
          >
            <ng-option value="">Tất cả</ng-option>
            <ng-option value="normal">Đơn thường</ng-option>
            <ng-option value="affiliate">Đơn affiliate</ng-option>
            <ng-option value="give_away">Đơn tặng</ng-option>
          </ng-select>
        </div>
        <div class="form-group col-12 col-md-4 col-lg-3">
          <mat-form-field appearance="fill" class="mt-3">
            <mat-label>Chọn khoảng ngày </mat-label>
            <mat-date-range-input [formGroup]="range" [rangePicker]="picker">
              <input
                matStartDate
                formControlName="start"
                placeholder="Ngày bắt đầu"
              />
              <input
                matEndDate
                formControlName="end"
                placeholder="Ngày kết thúc"
              />
            </mat-date-range-input>
            <mat-datepicker-toggle
              matSuffix
              [for]="picker"
            ></mat-datepicker-toggle>
            <mat-date-range-picker #picker></mat-date-range-picker>
            <mat-error
              *ngIf="range.controls.start.hasError('matStartDateInvalid')"
              >Invalid start date</mat-error
            >
            <mat-error *ngIf="range.controls.end.hasError('matEndDateInvalid')"
              >Invalid end date</mat-error
            >
          </mat-form-field>
        </div>
        <div class="form-group col-12 col-md-4 col-lg-3 d-flex mt-4">
          <div class="col-4">
            <div style="min-width: 200px">
              <div class="form-group">
                <button class="btn btn-primary" (click)="submitFilter()">
                  {{ "PAGE.REPORT.Search" | translate }}
                </button>
                <button
                  class="btn btn-dark ml-2"
                  *ngIf="searching"
                  (click)="clearFilter()"
                >
                  {{ "FORM.Clear" | translate }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="table-responsive">
      <table
        id="basic-datatable"
        class="table table-bordered dt-responsive nowrap no-footer dtr-inline orders-table"
      >
        <colgroup>
          <col style="width: 16px" />
          <col style="width: 60px" />
          <col style="width: 100px" *ngIf="!full_name.includes('DD_CSKH')" />
          <col style="width: 150px" />
          <col style="width: 72px" />
          <col style="width: 60px" />
          <col style="width: 60px" />
          <col style="width: 48px" />
          <col style="width: 60px" />
          <col style="width: 40px" />
          <col style="width: 48px" />
          <col style="width: 48px" />
        </colgroup>
        <thead>
          <tr class="bg-table">
            <th>#</th>
            <th class="first-column">{{ "Tên cửa hàng" | translate }}</th>
            <th *ngIf="!full_name.includes('DD_CSKH')">
              {{ "Thông tin khách hàng" | translate }}
            </th>
            <th>{{ "Thông tin tài khoản" | translate }}</th>
            <th>{{ "Mã thiết bị" | translate }}</th>
            <th class="table-column">{{ "Địa chỉ" | translate }}</th>
            <th>{{ "Thông tin DV" | translate }}</th>
            <th>{{ "Mã giới thiệu" | translate }}</th>
            <th>{{ "Trạng thái đơn" | translate }}</th>
            <th>{{ "Tổng tiền" | translate }}</th>
            <th>{{ "Loại đơn" | translate }}</th>
            <th class="table-column">{{ "Ngày tạo" | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let data of listData; let i = index">
            <td class="table-column">
              {{ pageSize * (pageIndex - 1) + i + 1 }}
            </td>
            <td class="table-column hyperlink" (click)="viewDetails(data)">
              {{ data.workspace_name }}
            </td>
            <td *ngIf="!full_name.includes('DD_CSKH')" class="table-column">
              <div>{{ data.user_phone }}</div>
              <div>{{ data.full_name }}</div>
            </td>
            <td class="table-column">
              <div>{{ data.terminal_bank_acc }}</div>
              <div>{{ data.terminal_bank_acc_name }}</div>
            </td>
            <td class="table-column">
              {{ data.serial_number ? data.serial_number : "--" }}
            </td>
            <td class="table-column">
              <div>
                {{
                  data.delivery_method == "direct" ? "Đơn trực tiếp" : "Đơn online"
                }}
              </div>
              <div>
                {{ data.to_province_name || data.terminal_province || "--" }}
              </div>
            </td>
            <td class="table-column">
              <div>
                <span
                  class="badge font-size-12"
                  [ngClass]="{
                    'badge-info': data.device_name === 'Loa 4G',
                    'badge-primary': data.device_name === 'Loa WIFI',
                    'badge-secondary':
                      data.device_name !== 'Loa 4G' &&
                      data.device_name !== 'Loa WIFI'
                  }"
                >
                  {{
                    data.device_name === "Loa 4G" ||
                    data.device_name === "Loa WIFI"
                      ? data.device_name
                      : "Loa 4G+WIFI"
                  }}
                  x {{ data.quantity }}
                </span>
              </div>
              <div class="mt-1">
                <span
                  class="badge font-size-12"
                  [ngClass]="{
                    'badge-secondary': data.original_duration == 3,
                    'badge-info': data.original_duration == 6,
                    'badge-warning': data.original_duration == 12,
                    'badge-success': data.original_duration == 60,
                    'badge-dark':
                      data.original_duration != 3 &&
                      data.original_duration != 6 &&
                      data.original_duration != 12 &&
                      data.original_duration != 60
                  }"
                  *ngIf="data.original_duration"
                  >{{ data.original_duration }} tháng</span
                >
                <span *ngIf="!data.original_duration">--</span>
              </div>
            </td>
            <td class="table-column">{{ data.referrer }}</td>
            <td class="table-column">
              <span>{{ data.status | translate }}</span>
            </td>
            <td class="table-column">
              {{
                data?.amount
                  ? data.amount
                  : ((+data.discounted_price || 0) + (+data.fix_ship_fee || 0)
                    | number : "1.0-0")
              }}
              <sup><ins>đ</ins></sup>
            </td>
            <td class="table-column">
              <span
                class="badge font-size-12"
                [ngClass]="{
                  'badge-secondary': data.service_package_type === 'normal',
                  'badge-info': data.service_package_type === 'affiliate',
                  'badge-success': data.service_package_type === 'give_away'
                }"
              >
                {{ serviceTypeMap[data.service_package_type] || "--" }}
              </span>
            </td>
            <td class="table-column">
              {{ data.created_at | date : "dd/MM/yyyy HH:mm" }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="row justify-content-md-between align-items-md-center mt-2">
      <div class="col-sm-12 col-md-5">
        <div
          class="dataTables_info mb-2"
          id="tickets-table_info"
          role="status"
          aria-live="polite"
        >
          {{ "TABLE.Showing" | translate }}
          {{ pageSize * pageIndex - pageSize + 1 }}
          {{ "TABLE.to" | translate }} {{ pageSize * pageIndex }}
          {{ "TABLE.of" | translate }} {{ totalCount }}
          {{ "TABLE.entries" | translate }}
        </div>
      </div>
      <!-- Pagination -->
      <div
        class="col-sm-12 col-md-5 d-flex align-items-center justify-content-end"
      >
        <div class="text-md-right float-md-right pagination-rounded">
          <ngb-pagination
            [collectionSize]="totalCount"
            [(page)]="pageIndex"
            [pageSize]="pageSize"
            [maxSize]="5"
            [ellipses]="true"
            (pageChange)="fetchData()"
          >
          </ngb-pagination>
        </div>
        <div class="dataTables_length ml-3" id="tickets-table_length">
          <label class="d-inline-flex align-items-center mb-0">
            {{ "TABLE.Show" | translate }}
            <select
              name="tickets-table_length"
              aria-controls="tickets-table"
              name="pageSize"
              [(ngModel)]="pageSize"
              (ngModelChange)="pageIndex = 1; fetchData()"
              class="custom-select custom-select-sm form-control form-control-sm mx-2"
            >
              <option [ngValue]="10">10</option>
              <option [ngValue]="25">25</option>
              <option [ngValue]="50">50</option>
              <option [ngValue]="100">100</option>
            </select>
            {{ "TABLE.entries" | translate }}
          </label>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #content role="document" let-modal="close">
  <div class="modal-header">
    <h5 class="modal-title">
      {{ (formData.value.id ? "FORM.Edit" : "FORM.AddNew") | translate }}
    </h5>
    <!-- <div *ngIf="makeForm('password').hasError('required')" class="error-message">
              Mật khẩu không được bỏ trống.
          </div> -->
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modal('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body p-3">
    <div class="text-left">
      <form (ngSubmit)="saveData()" [formGroup]="formData">
        <div class="row">
          <!-- <div class="form-group row col-md-6">
                          <label class="col-md-2 col-form-label required_label">{{'Imei' | translate}}</label>
                          <div class="col-md-10">
                              <input type="text" class="form-control" formControlName="imei"
                                  [ngClass]="{'is-invalid': submitted && form.imei.errors}" />
                            
                          </div>
                      </div> -->
          <!-- <div class="form-group row col-md-12" *ngIf="!formData.value.id"> -->

          <div class="form-group row col-md-12">
            <label class="col-md-2 col-form-label required_label">{{
              "Serial" | translate
            }}</label>
            <div class="col-md-10">
              <input
                type="text"
                class="form-control"
                formControlName="serial_number"
                [ngClass]="{
                  'is-invalid': submitted && form.serial_number.errors
                }"
              />
            </div>
          </div>
          <div class="form-group row col-md-12">
            <label class="col-md col-form-label required_label">{{
              "Model" | translate
            }}</label>
            <div class="col-md-10">
              <select
                class="form-select"
                aria-label="Default select example"
                class="form-control"
                formControlName="model"
                [ngClass]="{ 'is-invalid': submitted && form.model.errors }"
              >
                <option value="{{ item }}" *ngFor="let item of listModel">
                  {{ item }}
                </option>
              </select>
              <!-- <input type="text" class="form-control" formControlName="model"
                                  [ngClass]="{'is-invalid': submitted && form.model.errors}" />
                             -->
            </div>
          </div>

          <div class="form-group row col-md-12">
            <label class="col-md-2 col-form-label required_label">{{
              "Phiên bản" | translate
            }}</label>
            <div class="col-md-10">
              <select
                class="form-select"
                aria-label="Default select example"
                class="form-control"
                formControlName="version"
                [ngClass]="{ 'is-invalid': submitted && form.version.errors }"
              >
                <option value="{{ item }}" *ngFor="let item of listVersion">
                  {{ item }}
                </option>
              </select>
            </div>
          </div>
          <!-- <div class="form-group row col-md-12">
                          <label class="col-md-2 col-form-label required_label">{{'Trạng thái' | translate}}</label>
                          <div class="col-md-10">
                              <select class="form-select" aria-label="Default select example" class="form-control" formControlName="status"  [ngClass]="{'is-invalid': submitted && form.status.errors}">
                                  <option value="0" >Ngoại tuyến</option>
                                  <option value="1" >Trực tuyến</option>
                              </select>
                          </div>
                      </div>   -->
        </div>

        <div class="text-center">
          <button
            type="button"
            class="btn btn-secondary btn-lg mr-3"
            style="width: 150px"
            (click)="modal('close click')"
          >
            {{ "Đóng" | translate }}
          </button>
          <button
            type="submit"
            class="btn btn-success btn-lg"
            style="width: 150px"
          >
            {{ "Lưu" | translate }}
          </button>
          <!-- <button type="button" class="btn btn-secondary btn-sm" style="width: 150px"
                      (click)="modal('close click')">{{'FORM.Close' | translate}}</button>
                  <button type="button" class="btn btn-primary btn-sm ml-3" style="width: 150px"
                      (click)="updateFormNote()">{{'FORM.Save' | translate}}</button> -->
        </div>
      </form>
    </div>
  </div>
</ng-template>

<ng-template #contentLink role="document" let-modal="close">
  <div class="modal-header">
    <h5 class="modal-title">Liên kết thiết bị với đơn hàng</h5>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modal('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body p-3">
    <div class="text-left">
      <form (ngSubmit)="deviceLink(formData.value)" [formGroup]="formData">
        <div class="row">
          <div class="form-group row col-md-12">
            <label class="col-md-2 col-form-label required_label">{{
              "Đơn hàng" | translate
            }}</label>
            <div class="col-md-10">
              <input
                type="text"
                class="form-control"
                formControlName="data"
                [ngClass]="{ 'is-invalid': submitted && form.data.errors }"
                disabled
              />
            </div>
          </div>

          <div class="form-group row col-md-12">
            <label class="col-md-2 col-form-label required_label">{{
              "Số thiết bị cần gán" | translate
            }}</label>
            <div class="col-md-10">
              <input
                disabled
                type="text"
                class="form-control"
                formControlName="quantity"
                [ngClass]="{ 'is-invalid': submitted && form.quantity.errors }"
              />
            </div>
          </div>
          <div class="form-group row col-md-12">
            <label class="col-md-2 col-form-label required_label">{{
              "Thiết bị" | translate
            }}</label>
            <div class="col-md-10">
              <ng-select
                [items]="listDevices"
                bindLabel="serial_number"
                bindValue="serial_number"
                formControlName="serial_number"
                [maxSelectedItems]="formData.get('quantity').value"
                [multiple]="true"
                placeholder="{{ 'Chọn thiết bị' | translate }}"
                [ngClass]="{
                  'is-invalid': submitted && form.serial_number.errors
                }"
              >
              </ng-select>
            </div>
          </div>
        </div>

        <div class="text-center">
          <button
            type="button"
            class="btn btn-secondary btn-lg mr-3"
            style="width: 150px"
            (click)="modal('close click')"
          >
            {{ "Đóng" | translate }}
          </button>
          <button
            type="submit"
            class="btn btn-success btn-lg"
            style="width: 150px"
          >
            {{ "Lưu" | translate }}
          </button>
        </div>
      </form>
    </div>
  </div>
</ng-template>

<ng-template #contentDetail role="document" let-modal="close">
  <div class="modal-header">
    <h5 class="modal-title">Chi tiết đơn hàng Online</h5>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modal('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body p-3">
    <div class="text-left">
      <form (ngSubmit)="deviceLink(formData.value)" [formGroup]="formData">
        <div class="row">
          <div class="form-group row col-md-12">
            <label class="col-md-2 col-form-label required_label">{{
              "Người nhận" | translate
            }}</label>
            <div class="col-md-10">
              <input
                type="text"
                class="form-control"
                formControlName="customer_name"
                [ngClass]="{
                  'is-invalid': submitted && form.customer_name.errors
                }"
                disabled
              />
            </div>
          </div>

          <div class="form-group row col-md-12">
            <label class="col-md-2 col-form-label required_label">{{
              "Số điện thoại" | translate
            }}</label>
            <div class="col-md-10">
              <input
                disabled
                type="text"
                class="form-control"
                formControlName="phone"
                [ngClass]="{ 'is-invalid': submitted && form.phone.errors }"
              />
            </div>
          </div>
          <div class="form-group row col-md-12">
            <label class="col-md-2 col-form-label required_label">{{
              "Địa chỉ" | translate
            }}</label>
            <div class="col-md-10">
              <input
                disabled
                type="text"
                class="form-control"
                formControlName="address"
                [ngClass]="{ 'is-invalid': submitted && form.address.errors }"
              />
            </div>
          </div>
        </div>

        <div class="text-center">
          <button
            type="button"
            class="btn btn-secondary btn-lg mr-3"
            style="width: 150px"
            (click)="modal('close click')"
          >
            {{ "Đóng" | translate }}
          </button>
          <!-- <button
            type="submit"
            class="btn btn-success btn-lg"
            style="width: 150px;"
          >
            {{'Lưu' | translate}}
          </button> -->
        </div>
      </form>
    </div>
  </div>
</ng-template>

<ng-template #contentKeyword let-modalHis="close">
  <div class="modal-header">
    <h5 class="modal-title">List keyword of "{{ selectedIncident.name }}"</h5>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modalHis('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body p-3">
    <div class="mb-3" *ngIf="formNewKeyword">
      <h5 class="font-size-14">Add New Keyword</h5>
      <form
        [formGroup]="formNewKeyword"
        (submit)="onSubmitFormKeyword(2)"
        class="d-flex"
      >
        <input
          type="text"
          class="form-control form-control-sm"
          style="width: 250px"
          formControlName="name"
        />
        <button class="btn btn-primary btn-sm ml-3" style="width: 150px">
          Add
        </button>
      </form>
    </div>
    <div class="table-responsive">
      <table
        id="basic-datatable"
        class="table table-bordered dt-responsive nowrap no-footer dtr-inline"
      >
        <thead>
          <tr>
            <th width="50">#</th>
            <th>Name</th>
            <!-- <th>Thời gian</th> -->
            <th width="170"></th>
          </tr>
        </thead>
        <tbody *ngFor="let data of dataKeyword; let i = index">
          <tr>
            <td class="table-column">{{ i + 1 }}</td>
            <td class="table-column">
              <ng-container
                *ngIf="
                  selectedKeyword?.id == data.id && formEditKeyword;
                  else normal
                "
              >
                <form
                  [formGroup]="formEditKeyword"
                  (submit)="onSubmitFormKeyword(1)"
                >
                  <input
                    type="text"
                    class="form-control form-control-sm"
                    formControlName="name"
                  />
                </form>
              </ng-container>
              <ng-template #normal>{{ data.name }}</ng-template>
            </td>
            <!-- <td class=" table-column">{{data.created_at*1000 | date:'dd/MM/yyyy HH:mm'}}</td> -->
            <td class="table-column">
              <div class="d-flex" style="gap: 10px">
                <a
                  class="btn btn-sm btn-success"
                  href="javascript: void(0);"
                  (click)="editKeyword(data, i)"
                >
                  <i class="mdi mdi-account-edit"></i
                  >{{ "FORM.Edit" | translate }}</a
                >
                <a
                  class="text-white btn btn-sm btn-danger"
                  (click)="onDeleteKeyword(data.id)"
                  ><i class="mdi mdi-delete"></i
                  >{{ "FORM.Delete" | translate }}</a
                >
              </div>
              <!-- <button class="btn" (click)="editKeyword(data,i)">Sửa</button>
                              <button>Xoá</button> -->
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</ng-template>
